module.exports = __webpack_public_path__ + "img/client-search-with-circle-transparent-100x100.1d2c663e.png";